import { Component, inject } from '@angular/core';
import { CartItemStateService } from '../../../services/cart-item-state.service';
import { LibModulesWolcModule } from '../../lib-modules-wolc.module';

@Component({
  selector: 'btlib-order-group-items',
  standalone: true,
  imports: [LibModulesWolcModule],
  templateUrl: './order-group-items.component.html',
  styleUrl: './order-group-items.component.scss'
})
export class BtOrderGroupItemsComponent {
  state = inject(CartItemStateService);
  groupItems = this.state.groupItems;

  updateQuantity(itemId: number, quantity: number): void {
    this.state.toggleGroupItem(itemId, quantity);
  }
}
